<template>
  <v-col cols="12" class="pa-0 mb-12">
    <v-row no-gutters :class="color">
      <v-col cols="12" lg="8" class="pa-5 pa-lg-8 d-flex flex-column justify-space-between">
        <div v-orphans>
          <h2
            class="text-h3 font-weight-medium mb-3"
            :class="{
              'sz-red--text': styleVariant === 'primary',
              'ap-blue--text': styleVariant === 'secondary'
            }"
            v-html="title"
          />
          <p
            class="f-18 sz-primary-grey--text mb-5 pre-line"
            :class="{ 'small-line-height': smallLineHeight }"
            v-html="text"
          />
        </div>
        <div v-if="link?.href" v-orphans class="px-0 d-block d-md-flex">
          <BaseButton
            class="mx-auto"
            :variant="styleVariant === 'secondary' ? 'ap' : 'primary'"
            :href="link.href"
            arrow
          >
            {{ link?.text }}
          </BaseButton>
        </div>
        <div />
      </v-col>
      <v-col cols="12" lg="4" class="mt-0 mt-md-0">
        <v-img class="h-100" :src="`${publicPath}${image}`" width="auto" position="right" cover />
      </v-col>
    </v-row>
  </v-col>
</template>

<script setup>
import BaseButton from '@/components/widgets/BaseButton.vue'
defineProps({
  publicPath: {
    type: String,
    default: ''
  },
  title: {
    required: true,
    type: String
  },
  text: {
    required: true,
    type: String
  },
  link: {
    type: Object,
    default: () => {
      return { href: '#', text: null }
    }
  },
  image: {
    type: [String, Object]
  },
  color: {
    type: String,
    default: 'sz-primary-background'
  },
  id: {
    default: false
  },
  smallLineHeight: {
    type: Boolean,
    default: false
  },
  // 'primary' or 'secondary' - change to enum after migrating to ts
  styleVariant: {
    type: String,
    default: 'primary'
  }
})
</script>
